import { RequestState, VideoPlayerResourcesState } from './types';

export const videoPlayerResourcesInitialState: VideoPlayerResourcesState = {
  songDetails: { state: RequestState.loading },
  background: { state: RequestState.loading },
  videoMetadata: { state: RequestState.loading },
  swipeColors: { state: RequestState.loading },
  lyrics: { state: RequestState.loading },
  instrumental: { state: RequestState.loading },
  vocalGuide: { state: RequestState.loading },
  fadeDuration: 300,
};
